// removed by extract-text-webpack-plugin
module.exports = {"root":"terms-and-conditions-text--root--enfMr5mb","title":"terms-and-conditions-text--title--1dvGk6_i","list":"terms-and-conditions-text--list--2f_BhUCV","section":"terms-and-conditions-text--section--2dETos_3","subtitle":"terms-and-conditions-text--subtitle--2euWVKhH"};


//////////////////
// WEBPACK FOOTER
// ./components/terms-and-conditions-text/styles.css
// module id = ./components/terms-and-conditions-text/styles.css
// module chunks = 0